import { navigateTo } from 'nuxt/app'
import { useUsersStore } from '~/stores/users'

export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUsersStore()

  if (
    to.name === 'account-nieuwe-contactgegevens' &&
    !userStore.specificUser?.isArchived
  ) {
    return navigateTo({ name: 'account' })
  }
})
